import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Menu, User, Settings, Client } from '@store/models';
import { LegacyService } from 'app/legacy/legacy.service';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class HeaderComponent {

    @Input() menu: Menu[];
    @Input() currentUser: User;
    @Input() isSupporter: boolean;
    @Input() isFaglig: boolean;
    @Input() currentClient: Client;
    @Input() sidebarCollapsed: boolean;
    @Input() officeSettings: Settings;
    @Output() toggleSidebar = new EventEmitter<boolean>();
    @Output() methodCall = new EventEmitter<string>();
    navbarCollapsed = true;
    hasLegacy = environment.legacyUrl !== '';

    constructor(
        private legacyService: LegacyService
    ) {}

    openLinkInTab(url: string) {
        const tab = window.open(url, '_blank');
        tab.focus();
    }

    openWindow(url: string) {
        window.open(url, 'newwindow', 'resizable=yes,scrollbars=yes,width=1300,height=800');
    }

    onMethodCall(method: string) {
        if (method === 'moms' && this.officeSettings.moms2) {
            method = 'moms2';
        }
        this.methodCall.emit(method);
    }

    openLegacy(url: string) {
        this.legacyService.navigate(url, '', 'resizable=yes,scrollbars=yes,width=1300,height=800');
    }

}
